var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo"},[_c('router-link',{staticClass:"logo--title",attrs:{"to":{name: 'home'},"tag":"h1"}},[_vm._v("Jia Szeto Paris")]),_vm._v(" "),_c('router-link',{staticClass:"logo--subtitle",attrs:{"to":{name: 'home'},"tag":"h2"}},[_vm._v("Stylist")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4593aa2c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = 46
// module chunks = 0